<m-modal
  [visible]="visible()"
  [showHeader]="showHeader()"
  [showFooter]="showFooter()"
  [modal]="true"
  appendTo="body"
  styleClass="rounded-lg overflow-hidden border-white">
  <div
    class="flex flex-col gap-3 content-center items-center justify-center p-6 w-[600px]">
    <img src="assets/images/ufo-loader.svg" width="180px" alt="Loading" />
    <div class="dp2 text-gray-1000">{{ message() }}</div>
    <div class="w-[276px]">
      <m-progress-bar
        [mode]="'indeterminate'"
        styleClass="w-full indeterminate"></m-progress-bar>
    </div>
  </div>
</m-modal>
